import Swiper, { Navigation, Pagination } from 'swiper';

interface TestimonialSliderProps {
    el: HTMLElement;
}

Swiper.use([Navigation, Pagination]);

const PROFILE_ACTIVE_CLASS = 'is-active';

// Run the functions on document ready
const TestimonialSlider = ({ el }: TestimonialSliderProps) => {
    const profileButtons = el.querySelectorAll('.testimonial-profile-item');
    const swiperContainer: HTMLElement | null = el.querySelector('.swiper-testimonial-slider');

    if (!profileButtons || !swiperContainer) return;

    const profileGridColumnContainer = el.querySelector('.testimonial-slider-profile-grid .column-container');
    const colClass = profileButtons.length >= 6 ? 6 : profileButtons.length;

    profileGridColumnContainer?.classList.add(`cols-${colClass}`);

    const setActiveProfileButton = (index: number) => {
        profileButtons.forEach(profileButton => {
            profileButton.classList.remove('is-active');
        });
        profileButtons[index].classList.add(PROFILE_ACTIVE_CLASS);
    };

    const swiper = new Swiper(swiperContainer, {
        init: false,
        spaceBetween: 16,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 24
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
            clickable: true
        },
        on: {
            init(swiperObject) {
                setActiveProfileButton(swiperObject.realIndex);
            },
            slideChange(swiperObject) {
                setActiveProfileButton(swiperObject.realIndex);
            }
        }
    });

    swiper.init();

    profileButtons.forEach((profileButton, index) => {
        profileButton.addEventListener('click', () => {
            if (profileButton.classList.contains('is-active')) return;

            setActiveProfileButton(index);
            swiper.slideToLoop(index);
        });
    });
};

export default TestimonialSlider;
